import { Injectable, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class NotificationService {
  private successHeading = 'Success';
  private errorHeading = 'Error';

  constructor(
    private toastr: ToastsManager,
    private translate: TranslateService
  ) {}

  setContainerRef(vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  success(message) {
    this.toastr.success(this.translateSwal(message));
  }

  error(message) {
    this.toastr.error(this.translateSwal(message));
  }

  translateSwal(path) {
    let message = '';
    this.translate.get('MESSAGES.' + path).subscribe((res: string) => {
      message = res;
    });
      return message;
  }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/notification.service.ts